import PropTypes from 'prop-types';
import GoFetch from '~/js/modules/fetchling';

const internals = {
  loaderHelper(show = true) {
    if (!show) {
      $('.loader').fadeOut(1500);
      document.querySelector('.loader').classList.remove('show-loader');
      $('body').removeClass('noscroll');

      return 0;
    }
    $('body').addClass('noscroll');
    document.querySelector('.loader').classList.add('show-loader');
    $('.loader').fadeIn(1200);

    return 0;
  }
};


export default class DeletePanel extends React.Component {
  static propTypes = {
    showPanel: PropTypes.bool,
    wishlistCode: PropTypes.string,
    wishlistName: PropTypes.string,
    showDeletePanelHandler: PropTypes.func,
    confirmDeletedWishlistHandler: PropTypes.func
  };

  constructor() {
    super();
  }

  _deleteWishlist = () => {
    const deleteWishlistRequest = new GoFetch();
    const { wishlistCode: wishListCode } = this.props;
    const requestBody = { wishListCode, csrfToken: window.beaches_app.page.csrfToken };
    const { _closeModalHandler} = this;

    internals.loaderHelper();

    deleteWishlistRequest.post('/wishlist/delete/', null, requestBody)
      .then( async() => {
        await this.props.confirmDeletedWishlistHandler();
        await _closeModalHandler();
        await internals.loaderHelper(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  _closeModalHandler = () => {
    // https://github.com/facebook/react/issues/3249
    const onClickEvent = document.createEvent('HTMLEvents');

    onClickEvent.initEvent('click', true, true);
    const target = $('.mfp-close').get(0);

    target.dispatchEvent(onClickEvent);
  }

  render() {
    return (
      <section className="wishlist-collage-delete-panel true pr txt-center">
        <h4 className="font-normal">DELETE WISHLIST CONFIRMATION</h4>
        <hr/>
        <p>
          {
            `Please confirm you want to delete "${this.props.wishlistName}" wishlist. This action cannot be undone, all the wishlist content will be lost.`
          }
        </p>
        <div className="row around-xs center-lg">
          <div className="xs-6 lg-4">
            <button className="btn-wddng-theme arial font-bold" onClick={ this._closeModalHandler }>CANCEL</button>
          </div>
          <div className="xs-6 lg-4">
            <button className="btn-wddng-theme arial font-bold" onClick={ this._deleteWishlist }>DELETE</button>
          </div>
        </div>
      </section>
    );
  }
}
